import { NameDto } from 'api/Common/Types'

export interface PlatformDownloadLinkDto {
  id: string
  productLink: string
  enabled: boolean
  order: number
  platformType: NameDto
  operatingSystem: NameDto
  tickmillCompany: NameDto
  selected?: boolean
}

export enum PlatformLinkPageKey {
  platformLink = 'productLink',
  platform = 'platformType.name',
  operatingSystem = 'operatingSystem.name',
  company = 'tickmillCompany.name',
  order = 'order',
  enabled = 'enabled',
}
